(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-policy-page"] && !Shopify.designMode) return;
  try {
    
  function initFaqPolicyPages() {
    document.querySelectorAll('[data-faq-policy-page]').forEach(function (section) {
      if (section.dataset.faqPolicyInitialized === 'true') return;
      section.dataset.faqPolicyInitialized = 'true';

      var links = Array.from(section.querySelectorAll('[data-faq-policy-nav]'));
      var groups = Array.from(section.querySelectorAll('[data-faq-policy-group]'));
      var disclosures = Array.from(section.querySelectorAll('.faq-policy-page__item'));
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var ticking = false;

      disclosures.forEach(function (item) {
        var summary = item.querySelector('.faq-policy-page__summary');
        var answer = item.querySelector('.faq-policy-page__answer');
        var animation = null;

        if (!summary || !answer) return;

        function cleanUp(open) {
          item.open = open;
          item.classList.remove('is-expanding', 'is-closing');
          item.style.removeProperty('height');
          item.style.removeProperty('overflow');
          item.style.removeProperty('will-change');
          animation = null;
        }

        function setOpen(open) {
          if (reduceMotion.matches || typeof item.animate !== 'function') {
            if (animation) animation.cancel();
            cleanUp(open);
            return;
          }

          var startHeight = item.getBoundingClientRect().height;

          if (animation) animation.cancel();

          item.open = true;
          item.classList.toggle('is-expanding', open);
          item.classList.toggle('is-closing', !open);

          var endHeight = open
            ? summary.offsetHeight + answer.offsetHeight
            : summary.offsetHeight;

          item.style.height = startHeight + 'px';
          item.style.overflow = 'hidden';
          item.style.willChange = 'height';

          var nextAnimation = item.animate(
            {
              height: [startHeight + 'px', endHeight + 'px']
            },
            {
              duration: 460,
              easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
            }
          );

          animation = nextAnimation;

          nextAnimation.onfinish = function () {
            if (animation === nextAnimation) cleanUp(open);
          };

          nextAnimation.oncancel = function () {
            if (animation === nextAnimation) animation = null;
          };
        }

        summary.addEventListener('click', function (event) {
          event.preventDefault();
          var shouldOpen = !item.open || item.classList.contains('is-closing');
          setOpen(shouldOpen);
        });
      });

      function setActive(group) {
        var activeIndex = groups.indexOf(group);

        links.forEach(function (link, index) {
          var active = link.getAttribute('href') === '#' + group.id;
          var distance = Math.abs(index - activeIndex);

          link.classList.toggle('is-active', active);
          link.style.opacity = active ? '1' : (distance === 1 ? '0.25' : '0.05');

          if (active) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      function updateActive() {
        var current = groups[0];
        var trigger = window.innerHeight * 0.32;

        groups.forEach(function (group) {
          if (group.getBoundingClientRect().top <= trigger) current = group;
        });

        if (current) setActive(current);
        ticking = false;
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateActive);
      }

      links.forEach(function (link) {
        link.addEventListener('click', function () {
          var target = section.querySelector(link.getAttribute('href'));
          if (target) setActive(target);
        });
      });

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateActive();
    });
  }

  document.addEventListener('DOMContentLoaded', initFaqPolicyPages);
  document.addEventListener('shopify:section:load', initFaqPolicyPages);

  if (document.readyState !== 'loading') initFaqPolicyPages();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
